import { graphql } from '@eluve/graphql.tada';

export const appointmentFilesFragment = graphql(`
  fragment AppointmentFiles on Appointments {
    __typename
    id
    appointmentFiles {
      __typename
      appointmentId
      fileId
      fileType
      tags {
        __typename
        id
        metadata
        createdAt
        updatedAt
        resolvedAt
        isSelfResolved
        addedById
        addedByUser {
          __typename
          id
          email
          firstName
          lastName
          displayName
        }
        tag {
          __typename
          id
          tag
          isSystemTag
          isResolvable
        }
      }
      userUpload {
        __typename
        id
        status
        fileUrl
        originalFileName
        uploadedAt
        transcript {
          __typename
          id
          segmentId
          transcriptionStatus
          isFinalChunk
          appointment_segment {
            __typename
            id
            recordingStartedAt
            metadata
            device {
              __typename
              deviceType
              manufacturer
              model
              browserName
              operatingSystem
              microphoneName
            }
          }
        }
      }
    }
  }
`);

export const appointmentFilesQuery = graphql(
  `
    query appointmentFiles($tenantId: uuid!, $appointmentId: uuid!) {
      appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
        ...AppointmentFiles
      }
    }
  `,
  [appointmentFilesFragment],
);
